/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-06.
 */
import { last, isArray, get, initial as getInitial } from 'lodash';
import { parsePath } from './helpers';

/**
 * Example: removeFromArray(list, _.findIndex(e => e.id === id, list));
 * @param {array} list
 * @param {int} ind
 */
const removeFromArray = (list, ind) => {
    return ind > -1 ? [...list.slice(0, ind), ...list.slice(ind + 1)] : list;
};

const updateInArray = (list, ind, item) => {
    return ind === 0 ? [item, ...list.slice(1)] : (
        ind === list.length - 1 ? [...list.slice(0, ind), item] :
            [...list.slice(0, ind), item, ...list.slice(ind + 1)]
    );
};

//Updates item at index ind
const insertInArray = (list, ind, item) => {
    return ind === 0 ? [item, ...list] : (
        (ind === list.length || ind === -1) ? [...list, item] :
            [...list.slice(0, ind), item, ...list.slice(ind)]
    );
};

// a: String, b: Object => a -> b -> [[b,a]]
//for object x = {a: {b: {c: {d: 1} } } and path: ['a', 'b', 'c'] collect
//[[object]: [x, x.a, x.a.b, x.a.b.c ]
const getObjectPropertyPath = (path, obj) => {
    return path.reduce((acc, e) => {
        acc.push(last(acc)[e]);
        return acc;
    }, [obj]);
};

// a,b : String | Num, c : Object => [a] → b → c → c
// convert path to object/property pairs and overwrite object in path by copying
export const setValueIn = (path, value, obj) => {
    const initial = getObjectPropertyPath(getInitial(path), obj),
        updated = initial.reduceRight((acc, e, i) => {
            return isArray(e) ? updateInArray(e, parseInt(path[i], 10), acc) : Object.assign({}, e, { [path[i]]: acc });
        }, value);
    return updated;
};

export const addArrayItemIn = (path, item, obj) => {
    const target = get(obj, path),
        newArray = insertInArray(target, -1, item);

    return setValueIn(path, newArray, obj);
};

export const deleteArrayItemIn = (path, ind, obj) => {
    const target = get(obj, path),
        newArray = removeFromArray(target, ind);

    return setValueIn(path, newArray, obj);
};

export const setValuesIn = (targets, obj) => {
    let newState = obj;
    targets.forEach(({ path, value }) => {
        newState = setValueIn(parsePath(path), value, newState);
    });
    return newState;
};

export const updateItemIn = (path, { index, value }, obj) => {
    const target = get(obj, path);
    const newArray = Object.assign([], target, { [index]: value });
    return setValueIn(path, newArray, obj);
};

export const addPropertyInArray = (path, node, nodeValue, newProperty, propertyValue, state) => {
    let newState = state;
    newState[path].forEach((element) => {
        if (element[node] == nodeValue) {
            element[newProperty] = propertyValue;
            return;
        }
    });
    return newState;
};



// WEBPACK FOOTER //
// ./common/immutable.js